import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { WIDGET, } from '@voltmoney/schema';
import { APPLICATION_STATE, VoltWebSiteBaseLink } from '../../configs/constants';
import { ACTION } from './type';
import { goHome, needHelp } from './action';
import { getContactUsDetails, isMobile } from '../../configs/utils';
import SharedPropsService from '../../SharedPropsService';
export const template = async (height, contactUsDetails, showOnlyDownload) => ({
    layout: {
        id: ROUTE.INTEREST_CALCULATOR_APP,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'InterestCalculatorPageMainStack', type: WIDGET.INTEREST_CALCULATOR_WIDGET_APP }
        ]
    },
    datastore: {
        InterestCalculatorPageMainStack: {
            height: height,
            shareLinkAction: {
            // routeId: ROUTE.INTEREST_CALCULATOR,
            // type: ACTION.SHARE_LINK_REF,
            // payload: {}
            },
            baseLink: VoltWebSiteBaseLink,
            handleNeedHelp: {
                routeId: ROUTE.INTEREST_CALCULATOR_APP,
                type: ACTION.NEED_HELP,
                payload: {}
            },
            goBackAction: {
                routeId: ROUTE.INTEREST_CALCULATOR_APP,
                type: ACTION.GO_BACK,
                payload: {}
            },
            contactUsDetails: contactUsDetails,
            showOnlyDownload: showOnlyDownload
        }
    },
});
export const InterestCalculatorAppMf = {
    onLoad: async ({ getHeight, network, instrumentTrack }, { isFromDashboard = false }) => {
        const user = await SharedPropsService.getUser();
        if (user?.linkedApplications[0]?.applicationState === APPLICATION_STATE.COMPLETED) {
            instrumentTrack('interest_calculator_entry_clicked', {
                Screen: 'Dashboard'
            });
        }
        else {
            instrumentTrack('interest_calculator_entry_clicked', {
                Screen: 'Homescreen'
            });
        }
        const contactUsDetails = await getContactUsDetails();
        const _isMobile = isMobile;
        let showOnlyDownload = !_isMobile();
        return Promise.resolve(template(getHeight(), contactUsDetails, showOnlyDownload));
    },
    actions: {
        [ACTION.GO_BACK]: goHome,
        [ACTION.NEED_HELP]: needHelp,
    }
};
